import {
  isOrganisationActive,
  isProductAccessible,
  userCan
} from "@/lib/utils";
import notification from "element-ui/packages/notification";

const Onboarding = () => import("@/pages/products/verify-identity/onboarding");

const Base = () => import("@/pages/products/verify-identity/base");
const Index = () => import("@/pages/products/verify-identity/index");
const Verifications = () =>
  import("@/pages/products/verify-identity/verifications");
const Verify = () => import("@/pages/products/verify-identity/verify");

let checkRoutePermissions = (to, from, next, action = "service.logs.all") => {
  const allowRouteView = userCan("proxy", action);
  const allowAdmin = userCan("auth", "feature.saveorganisationfeature");

  let title = "";
  let message = "";

  if (isOrganisationActive()) {
    if (isProductAccessible("verify-id")) {
      if (allowRouteView) {
        next();
      } else {
        title = "Access Denied";
        message = "You are not authorized to view this page";
      }
    } else {
      if (allowAdmin) {
        next({ name: "verify-identity.onboarding" });
      } else {
        title = "Access Denied";
        message = "Organisation has no access. Contact admin";
      }
    }
  } else {
    if (userCan("auth", "organisation.update")) {
      next({ name: "organisation.index", hash: "#settings" });
      title = "Inactive Organisation";
      message = "You need to activate your organisation.";
    } else {
      next({ name: "home.index" });
      title = "Inactive Organisation";
      message = "Contact organisation admin.";
    }
  }

  if (title) {
    notification({
      title,
      message,
      customClass: "error"
    });
  }
};

const routes = () => {
  return [
    {
      path: "/verify-identity/",
      component: Base,
      redirect: {
        name: "verify-identity.index"
      },
      meta: {
        requiresAuth: true,
        layout: "app",
        childLayout: "product",
        label: "Verify Identity"
      },
      children: [
        {
          path: "onboarding",
          name: "verify-identity.onboarding",
          component: Onboarding,
          meta: {
            requiresAuth: true,
            layout: "app",
            label: "Onboarding"
          }
        },
        {
          path: "overview",
          name: "verify-identity.index",
          component: Index,
          meta: {
            requiresAuth: true,
            requiresAccountVerification: true,
            layout: "app",
            childLayout: "product",
            label: "Overview"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next, "service.logs.all");
          }
        },
        {
          path: "verifications",
          name: "verify-identity.verifications",
          component: Verifications,
          meta: {
            requiresAuth: true,
            requiresAccountVerification: true,
            layout: "app",
            childLayout: "product",
            label: "Verifications"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next);
          }
        },
        {
          path: "verify",
          name: "verify-identity.verifications.verify",
          component: Verify,
          meta: {
            requiresAuth: true,
            requiresAccountVerification: true,
            layout: "app",
            childLayout: "product",
            label: "Verify"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next);
          }
        }
      ]
    }
  ];
};

export default routes();
